import React from "react";
import { connect } from "react-redux";
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import { SetDepositMoneyStatus } from '$Deposits/store/actions/DepositAction'


class InputItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isPasswordVisible:false
        };
    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const {isPasswordVisible} = this.state;

        const {
            stateVal = '',
            onChange = () => {},
            placeholder = '',
            value = '',
            title,
            maxLength = 50,
        } = this.props
        const isPasswordType = title.includes("PIN")

        return (
            <>
                <p className="inputTitle">{title}</p>
                <div className={'input ' + (stateVal ? 'inputErr' : '')} >
                    <input
                        value={value}
                        placeholder={placeholder}
                        onChange={(e) => {onChange(e.target.value) }}
                        autoComplete={'initial'}
                        maxLength={maxLength}
                        type={!isPasswordType ? "text" : isPasswordVisible ? "text" : "password"}
                    />
                    {
                        isPasswordType && (
                            <div 
                                onClick={()=>{this.setState(prevState=> {return {...prevState, isPasswordVisible: !prevState.isPasswordVisible}})}} 
                                className={`eyeIcon ${isPasswordVisible ? "visibleIcon" :"invisibleIcon"}`}
                            />
                        )
                    }
                </div>
                {
                    stateVal &&
                    <div className='inputErrMsg'>
                        {stateVal}
                    </div>
                }
            </>
        );
    }
}

export default InputItem

